import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row } from "react-bootstrap";
import { getTours, getTourGroups } from "../Api/TourApi";
import Tour from "./Tour";

const Tours = () => {
  const [tourGroups, setTourGroups] = useState([]);
  const [selectedTag, setSelectedTag] = useState();
  const [isLoadingTours, setIsLoadingTours] = useState(true);
  const [origTours, setOrigTours] = useState([]);
  const [resultTours, setResultTours] = useState([]);

  useEffect(() => {
    const filtered = selectedTag
      ? origTours.filter(
          (t) => t["attributes"]["groups"] && t["attributes"]["groups"].includes(selectedTag)
        )
      : origTours;
    setResultTours(filtered);
  }, [selectedTag, origTours]);

  useEffect(() => {
    let cancelled = false;

    async function fetchTourGroups() {
      const response = await getTourGroups("all");
      if (!cancelled) {
        setTourGroups(
          response.data.sort(
            (a, b) => a["attributes"].readable_name - b["attributes"].readable_name
          )
        );
      }
    }
    fetchTourGroups();

    async function fetchTours() {
      const response = await getTours();
      if (!cancelled) {
        setOrigTours(
          response.data.sort(
            (a, b) => a["attributes"].sortOrder - b["attributes"].sortOrder
          )
        );
        setIsLoadingTours(false);
      }
    }
    fetchTours();

    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <div className="tour-filter">
        <button
          className={`tour-filter__btn${!selectedTag ? " tour-filter__btn--active" : ""}`}
          onClick={() => setSelectedTag(undefined)}
        >
          All Tours
        </button>
        {tourGroups.map((group) => {
          if (!group["attributes"]["frontpage"]) return null;
          const name = group["attributes"]["name"];
          return (
            <button
              key={name}
              className={`tour-filter__btn${selectedTag === name ? " tour-filter__btn--active" : ""}`}
              onClick={() => setSelectedTag(name)}
            >
              {group["attributes"]["readable_name"]}
            </button>
          );
        })}
      </div>

      <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Row style={{ margin: 0 }}>
          {!isLoadingTours &&
            resultTours.map((tour) => (
              <Tour key={tour["attributes"].pathTitle} tour={tour["attributes"]} />
            ))}
          {isLoadingTours && <div style={{ height: "2482px" }} />}
        </Row>
      </Container>
    </>
  );
};

export default Tours;
